import { rootApi } from 'root-api'

// Side-effect: inject fetchNewEventType onto rootApi
import './api'

export const fetchNewEventTypeEndpoint = rootApi.endpoints.fetchNewEventType
